import Vue from "vue";
import Router from "vue-router";
import Home from "./views/home/Home-3";
import Main from "./views/Main/Main-3";
import ArticleList from "./views/ArticleList";
import VideoList from "./views/VideoList";
import SearchList from "./views/SearchList";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "main",
      component: Main,
      redirect: { name: "home" },
      children: [
        {
          path: "/home",
          name: "home",
          component: Home
        },
        {
          path: "/articleList",
          name: "articleList",
          component: ArticleList
        },
        {
          path: "/videoList",
          name: "videoList",
          component: VideoList
        },
        {
          path: "/searchList",
          name: "searchList",
          component: SearchList
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  // 为页面设置 title
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  window.scrollTo(0, 0);
  next();
});
export default router;
